<template>
  <div class="login">
    <div class="phoneLogin">
      <div id="container" class="container">
        <h3 class="title"></h3>
        <span class="close" @click="phoneLoginClose"></span>
        <div class="login_main">
          <div class="account_login_wrap">
            <div class="account_login_tab">
              <span data-show="mobile" class="sms_tab phoneLoginActive"
                >验证码登录</span
              >
            </div>
            <div class="mobile_main login_type_main">
              <div class="account_item">
                <span class="mobile_tag">+86</span>
                <input
                  type="text"
                  class="mobile_login"
                  value=""
                  maxlength="11"
                  placeholder="输入手机号"
                  autocomplete="off"
                  v-model="phoneLoginData.phoneNumber"
                  ref="phoneNumber"
                />
              </div>
              <div class="account_item">
                <input
                  type="text"
                  class="captcha_login fl"
                  value=""
                  maxlength="6"
                  placeholder="输入验证码"
                  ref="codeNumber"
                  autocomplete="off"
                />
                <input
                  type="button"
                  class="get_code login_code fr"
                  value="获取验证码"
                  @click="getCode"
                />
              </div>
              <div class="agree_wrap">
                <div class="agree fl" :class="phoneLoginData.agree ? 'on' : ''">
                  <input
                    type="checkbox"
                    checked="checked"
                    class="login_agree fl"
                    name="agree_input"
                    value=""
                    @click="phoneLoginCBox"
                  />
                </div>
                <p class="fl">
                  已阅读并同意<a
                    href="//www.zlongame.com/html/login/agreement.html"
                    class="agreement"
                    >《用户协议》</a
                  ><a
                    href="//www.zlongame.com/html/login/privacy.html"
                    class="privacy"
                    >《隐私政策》</a
                  >
                </p>
              </div>
              <span
                class="mobile_submit login_btn submit_btn"
                @click="pointcardPhoneLoginBtn"
                >登录</span
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Toast } from 'vant';
import { debounce } from 'lodash';
import { teaminfo, join } from '../api/index';
export default {
  data() {
    return {
      currentAppkey: 1693534261653,
      phoneLoginData: {
        //手机验证登录相关
        userAgent: window.navigator.userAgent.toLowerCase(),
        u3dPcSupport:
          window.navigator.userAgent.toLowerCase().indexOf('untiypcsdk') > -1,
        mac_pc_sdk:
          window.navigator.userAgent.toLowerCase().indexOf('pd_mac_sdk') > -1,
        phoneNumber: '',
        codeNumber: '',
        agree: false,
        phoneLonginFlag: false, //手机号登录
        showNewInfoFlag: false //是否显示用户新样式
      },
      errorInfo: {
        10112101: '账号不存在',
        10112201: '账号不存在',
        10112102: '密码不正确',
        10112202: '密码不正确',
        10112103: '当前账号无效',
        10112203: '当前账号无效',
        10112106: '游戏用户无效',
        10112205: '游戏用户无效',
        10112108: '当前尝试频繁，请稍后再试',
        10112207: '当前尝试频繁，请稍后再试',
        10111402: '验证码不存在', //
        10111403: '验证码已失效',
        10113101: '手机号不存在',
        10113102: '账号无效',
        10113103: '验证码错误',
        10113104: '验证码已失效',
        10113105: '密码修改成功',
        10113106: '密码修改失败',
        10113111: '邮箱号不存在',
        10113112: '账号无效',
        10113113: '验证码错误',
        10113114: '验证码已失效',
        10113115: '密码修改成功',
        10113116: '密码修改失败',
        10: '请求的信息有误'
      }
    };
  },
  computed: {},
  watch: {},
  methods: {
    getQueryString(name) {
      var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i');
      var r;
      if (window.URLSearchParams) {
        var searchParams = new URLSearchParams(window.location.search);
        return searchParams.get(name);
      } else {
        r = window.location.search.substr(1).match(reg);
        if (r != null) {
          return decodeURIComponent(r[2]);
        }
        return null;
      }
    },
    phoneLoginClose() {
      this.$parent.loginShow = false;
    },
    phoneLoginCBox() {
      this.phoneLoginData.agree = !$('.login_agree[type=checkbox]').prop(
        'checked'
      )
        ? 'checked'
        : '';
    },
    pointcardPhoneLoginBtn: debounce(function () {
      let _this = this;
      let codeReg = /^\d{6}$/;
      let account = this.$refs.phoneNumber.value;
      let code = this.$refs.codeNumber.value;
      var isQa = /^(test|qa)-/.test(location.hostname),
        accountOrigin = '//member' + (isQa ? 'test' : '') + '.zlongame.com',
        accountUrl = accountOrigin + '/passport/main.zlongame',
        accountV2Url = accountOrigin + '/passport/v2/main.zlongame';
      let loginDate = {
        appkey: _this.currentAppkey,
        // device: 'webpay_' + $.md5(navigator.userAgent),
        device: localStorage.getItem('deviceId')
      };
      // console.log(loginDate);
      if (!/^1[3-9]\d{9}$/.test(account)) {
        return Toast('请输入正确的手机号');
      }
      if (!this.phoneLoginData.agree) {
        return Toast('请确认《用户协议》及《隐私政策》');
      }
      if (!code.match(codeReg)) {
        return Toast('请输入6位数字验证码');
      }
      loginDate.account = account;
      loginDate.action = 'access';
      loginDate.channel = 1000000002;
      loginDate.ecid = 3010181001; //渠道扩展id
      loginDate.version = 'v2';
      loginDate.tag = '1';
      loginDate.code = code;
      window.Ajax({
        url: accountOrigin + '/passport/method_login.zlongame',
        data: loginDate,
        success: function (data, textStatus) {
          var info = data.info;
          console.log(data);
          if (info == 10112206) {
            localStorage.setItem(
              `rox_lottery_card`,
              JSON.stringify({
                phone: account,
                userid: data.data.userid,
                token: data.data.token
              })
            );
            _this.$parent.init();
            if (_this.getQueryString('code')) {
              teaminfo({ code: _this.getQueryString('code') }).then((res) => {
                if (res.data.data.code == 0) {
                  if (res.data.data.list.length == 3) {
                    _this.$parent.getTip(`该队伍已满，无法加入`);
                  } else {
                    join({ code: _this.getQueryString('code') }).then(
                      (resChild) => {
                        if (resChild.data.data.code == 0) {
                          _this.$parent.getTip(`成功接受邀请，已加入队伍`);
                          _this.$parent.init(); //刷新队伍数据
                        } else {
                          _this.$parent.getTip(
                            `加入队伍失败--code:${resChild.data.data.code}`
                          );
                        }
                      }
                    );
                  }
                } else {
                  _this.$parent.getTip(
                    `查询队伍情况异常--code:${res.data.data.code}`
                  );
                }
              });
            }
          } else {
            Toast(_this.errorInfo[info]);
          }
        },
        error: function () {
          outerFunction('onLoginFailed', {
            message: '',
            customparams: params.customParams
          });
        }
      });

      var outerFunction = _this.phoneLoginData.mac_pc_sdk
        ? function (callback, json) {
            try {
              window.webkit.messageHandlers[callback].postMessage(
                '[' + JSON.stringify(json) + ']'
              );
            } catch (err) {
              onerror('', 'unityWebCore|' + callback, 0, 0, {
                stack: JSON.stringify(json) + err.stack
              });
              Toast(err);
            }
          }
        : _this.phoneLoginData.u3dPcSupport
        ? function (callback, json) {
            try {
              window[callback](json);
            } catch (err) {
              onerror('', 'unityWebCore|' + callback, 0, 0, {
                stack: JSON.stringify(json) + err.stack
              });
              Toast(err);
            }
          }
        : (function (callback, json) {
            var obj = {};
            'onLoginSuccess,onLoginFailed,gotoUrl,onQRClose,onRnaSuccess,onRnaCancel'
              .split(',')
              .forEach(function (f) {
                obj[f] = function (json) {
                  // console.log(f, json);
                };
              });
            return function (callback, json) {
              obj[callback](json);
            };
          })();
    }, 500),
    getCode: debounce(function () {
      var phoneLogin = $('.phoneLogin');
      var el = {
        mobile: phoneLogin.find('.account_reg'),
        sendBtn: phoneLogin.find('.get_code'),
        code: phoneLogin.find('.captcha_reg'),
        submit: phoneLogin.find('.reg_submit')
      };
      var account = this.$refs.phoneNumber.value;
      var isQa = /^(test|qa)-/.test(location.hostname),
        accountOrigin = '//member' + (isQa ? 'test' : '') + '.zlongame.com',
        accountUrl = accountOrigin + '/passport/main.zlongame',
        accountV2Url = accountOrigin + '/passport/v2/main.zlongame';
      if (!/^1[3-9]\d{9}$/.test(account)) {
        return Toast('请输入正确的手机号');
      } else {
        window.Ajax({
          type: 'POST',
          url: accountV2Url,
          data: {
            action: 'page',
            method: 'send',
            account: account,
            isMobileLogin: 1,
            appkey: this.currentAppkey,
            sign: $.pdEncry($.pdEncry(account))
          },
          dataType: 'json',
          success: function (data, textStatus) {
            if (data.status == 1) {
              valiCode(el.sendBtn, 60);
            } else {
              Toast('发送失败，请重新发送');
            }
          },
          error: function () {
            Toast('系统繁忙');
          }
        });
      }

      function valiCode($this, options) {
        var opt = options || 60,
          cur = 0,
          timer = null;
        var _this = $this;
        cur = opt;
        _this
          .attr('disabled', 'disabled')
          .addClass('active')
          .val(--cur + 's');
        timer = setInterval(function () {
          cur--;
          _this.val(cur + 's');
          if (cur == 0) {
            clearInterval(timer);
            cur = opt;
            _this.removeAttr('disabled').removeClass('active').val('重新发送');
          }
        }, 1000);
      }
    }, 500),
    AJAX() {
      let _this = this;
      var isQa = /^(test|qa)-/.test(location.hostname),
        accountOrigin = '//member' + (isQa ? 'test' : '') + '.zlongame.com',
        accountUrl = accountOrigin + '/passport/main.zlongame',
        accountV2Url = accountOrigin + '/passport/v2/main.zlongame',
        appkey = _this.currentAppkey;

      var inner_call = function (
        data,
        text,
        resp,
        header,
        originalSuccessCallback,
        callback
      ) {
        try {
          if (!data.ret) {
            console.log('328378748');
            Toast('网络异常');
          }
          data = penc.de(data.ret, resp, header['zl-p-nonce']);
          if (data.info != 15) {
            return originalSuccessCallback(data, text);
          }
          return (
            window.pdca &&
            window.pdca.create(function (json) {
              if (json.status == 'verify' && json.code == 0) {
                callback({ ticket: json.ticket, rand: json.rand });
              }
            }, data.data.zlckey)
          );
        } catch (err) {
          console.log(err, '3233333');
          Toast('网络异常');
        }
      };
      return (window.Ajax = function (options) {
        var settings = {
          type: 'post',
          url: accountUrl,
          data: {},
          dataType: 'json',
          success: function () {},
          error: function () {}
        };
        $.extend(true, settings, options);
        var c = penc.ps(settings.data);
        c.h.appkey = appkey;
        $.ajax({
          url: settings.url,
          headers: c.h,
          type: settings.type,
          data: { d: c.d },
          dataType: settings.dataType,
          success: function (data, text, resp) {
            inner_call(
              data,
              text,
              resp,
              c.h,
              settings.success,
              function (json) {
                $.extend(settings.data, json);
                Ajax(settings);
              }
            );
          },
          error: settings.error
        });
      });
    }
  },
  created() {},
  mounted() {
    this.AJAX();
  }
};
</script>
<style>
.M .login canvas {
  width: 100%;
  height: 100%;
}
</style>
<style scoped>
.phoneLogin {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.m .phoneLogin {
  transform: scale(0.76);
}
.m #container {
  height: auto;
}
.login {
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.8);
  position: fixed;
  z-index: 999;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
}
@import url('../assets/css/pointcard_pc.css');
@import url('../assets/css/pointcard_m.css');
@import url('../assets/css/style.css');
</style>